import { faGavel } from '@fortawesome/pro-light-svg-icons/faGavel';
import Button from '@propertypal/web-ui/src/buttons/Button';
import FontAwesomeIcon from '@propertypal/web-ui/src/icons/FontAwesomeIcon';
import Link from 'next/link';
import React from 'react';
import { Container, ButtonContainer, TextBox } from './UpcomingAuctionsBox.style';

const UpcomingAuctionsBox: React.FC = () => {
  return (
    <Container data-testid="upcoming-auctions-box">
      <FontAwesomeIcon icon={faGavel} />

      <TextBox>
        View all Upcoming Auctions
        <span> - Get a full list of dates, times and venues</span>
      </TextBox>

      <ButtonContainer>
        <Link href="/upcoming-auctions" prefetch={false}>
          <Button type="button">View Upcoming Auctions</Button>
        </Link>
      </ButtonContainer>
    </Container>
  );
};

export default UpcomingAuctionsBox;
